import { Banner } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PAYMENTS_LIMIT } from '../../constants';

export const PaymentLimitExceededBanner = () => (
    <Banner
        primaryText={<LocalizedText textKey={TextKey.MaximumPaymentsExceededMessagePrimary} />}
        secondaryText={
            <LocalizedText
                textKey={TextKey.MaximumPaymentsExceededMessageSecondary}
                substitutes={{ count: PAYMENTS_LIMIT }}
            />
        }
        variant="warning"
    />
);
